import React from "react";
import style from "../../style/Pages/Help/MyAccountHelp.module.css";
import { Link } from "react-router-dom";
import { IoPersonOutline } from "react-icons/io5";
import { TbArrowLeft } from "react-icons/tb";
import SecondaryLayout from "../../layouts/SecondaryLayout";

const MyAccountHelp = () => {
  return (
    <>
      <SecondaryLayout>
        <div className={style.accountHelpWrapper}>
          <Link to="/help" className={style.backLink}>
            <TbArrowLeft className={style.backIcon} /> Back to Help Center
          </Link>

          <div className={style.header}>
            <IoPersonOutline className={style.headerIcon} />
            <h1>My Account</h1>
          </div>

          <div className={style.content}>
            <p>
              Managing your account is simple and secure with our chat platform.
              Here's everything you need to know about account setup and
              customization:
            </p>

            <h2>🔐 Creating an Account</h2>
            <ul>
              <li>Click "Sign Up" on the login page.</li>
              <li>
                Enter your email, create a password, and complete the
                verification step.
              </li>
              <li>Click "Create Account" to get started.</li>
            </ul>

            <h2>🧾 Editing Your Profile</h2>
            <ul>
              <li>Navigate to the settings panel from the side menu.</li>
              <li>Click on "Profile Info".</li>
              <li>Update your name, profile picture, and status.</li>
              <li>Click "Save" to apply changes.</li>
            </ul>

            <h2>⚙️ Changing Your Password</h2>
            <ul>
              <li>Go to Settings → Security.</li>
              <li>Enter your current and new passwords.</li>
              <li>Click "Update Password".</li>
            </ul>

            <p>
              If you run into any trouble, don't hesitate to contact our support
              team.
            </p>
          </div>
        </div>
      </SecondaryLayout>
    </>
  );
};

export default MyAccountHelp;
